import { DatePicker, Input, InputNumber, Select, Tag } from "antd";
import { UserContactOutline } from "antd-mobile-icons";
import dayjs from 'dayjs'
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../common/api";
import { date2locale, toLocaleString } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";
import TablePage from "../components/TablePage";
import { UserInfoContext } from "../FetchUserInfo";

const renderStatus = (status) => {
    const val = {
        false: { label: "Da addebitare", color: "warning" },
        true: { label: "Addebitato", color: "success" },
    }[""+status];
    return <Tag color={val.color}>{val.label}</Tag>;
};

const columns = [
    {
        title: "ID",
        width: 100,
        key: "id",
        dataIndex: "id",
        render: (id) => <Link to={"" + id}>{id}</Link>,
    },
    {
        title: "Dipendente",
        width: 200,
        key: "employee",
        ellipsis: true,
        dataIndex: ["employee", "fullName"],
    },
    {
        title: "Descrizione",
        key: "description",
        ellipsis: true,
        dataIndex: "description",
    },
    {
        title: "Data",
        width: 150,
        key: "date",
        dataIndex: "date",
        render: date2locale,
    },
    {
        title: "Importo",
        width: 150,
        align: "end",
        key: "amount",
        dataIndex: "amount",
        render: toLocaleString,
    },
    {
        title: "Stato",
        key: "charged",
        width: 200,
        dataIndex: "charged",
        render: renderStatus,
    },
];
const filterItems = [
    {
        name: "id",
        label: "ID",
        formItem: {
            children: <InputNumber style={{ width: "100%" }} controls={false} precision={0} />,
        },
    },
    {
        name: "description",
        label: "Descrizione",
        formItem: {
            children: <Input />,
        },
    },
    {
        name: "charged",
        label: "Addebitato",
        readableValue: (value) =>
            ({
                true: 'Si',
                false: "No",
            })[value],
        formItem: {
            children: (
                <Select
                    showSearch
                    allowClear
                    options={[
                        { label: "Si", value: 'true'},
                        { label: "No", value: 'false'},
                    ]}
                />
            ),
        },
    },
    {
        name: "employee",
        label: "Dipendente",
        readableValue: (value) => JSON.parse(value).label,
        formItem: {
            children: (
                <DebounceSelect
                    fetchOptions={(query) =>
                        axiosInstance
                            .get("employeeCompact", {
                                params: {
                                    startDate: "1900-01-01",
                                    endDate: "9999-01-01",
                                    query,
                                },
                            })
                            .then(({ data }) =>
                                data.map((x) => ({
                                    label: x.fullName,
                                    value: x.id,
                                })),
                            )
                    }
                />
            ),
            props: {
                getValueProps: (value) => ({
                    value: value && JSON.parse(value),
                }),
                normalize: (value) => JSON.stringify(value),
            },
        },
    },
    {
        name: "date",
        label: "Data",
        readableValue: (value) =>
            `Dal ${date2locale(value.split("_")[0])} al ${date2locale(value.split("_")[1])}`,
        formItem: {
            children: <DatePicker.RangePicker style={{ width: "100%" }} format="DD/MM/YYYY" />,
            props: {
                getValueProps: (value) => ({
                    value: value ? [dayjs(value.split("_")[0]), dayjs(value.split("_")[1])] : [],
                }),
                normalize: (value) =>
                    value.length === 2 &&
                    value[0].format("YYYY-MM-DD") + "_" + value[1].format("YYYY-MM-DD"),
            },
        },
    },
];

export default function () {
    const navigate = useNavigate();
    const userInfo = useContext(UserInfoContext)
    const fetchData = (params) => {
        if (params.employee) params.employee = JSON.parse(params.employee).value;
        if(params.date){
            params.startDate = params.date.split("_")[0];
            params.endDate = params.date.split("_")[1];
            delete params.date;
        }
        return axiosInstance.get("charge", { params });
    };
    return (
        <TablePage
            toolbarProps={{
                addAction: userInfo.permissions?.includes("charge.create")
                    ? () => navigate("new")
                    : null,
            }}
            fetchFunction={fetchData}
            columns={columns}
            enableSelection={false}
            filterItems={filterItems}
        />
    );
}
